import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("h2", { class: "h5" }, " Are you sure you want to delete your subscription? ")
], -1)
const _hoisted_2 = /*#__PURE__*/_createElementVNode("p", null, "You will no longer receive SMS updates for this route once you delete your subscription.", -1)

import { ConfirmModal } from '../ConfirmModal';


export default /*#__PURE__*/_defineComponent({
  __name: 'DeleteRouteSubscriptionModal',
  props: {
    to: {},
    error: {}
  },
  emits: ["cancel", "confirm"],
  setup(__props: any, { emit: __emit }) {



const emit = __emit;

const handleConfirm = () => {
  emit('confirm');
};

const handleCancel = () => {
  emit('cancel');
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(ConfirmModal), {
    to: _ctx.to,
    error: _ctx.error,
    onConfirm: handleConfirm,
    onCancel: handleCancel
  }, {
    default: _withCtx(() => [
      _hoisted_1,
      _hoisted_2
    ]),
    _: 1
  }, 8, ["to", "error"]))
}
}

})